import { useEffect, useState } from "react";
import { Brand, StatusBadge } from "../components/Brand";
import { CommunityFooter } from "../components/CommunityFooter";
import { clientApi } from "../api";

export function HomePage() {
  const [state, setState] = useState<"resolving" | "waiting" | "error">("resolving");

  useEffect(() => {
    let cancelled = false;
    let checking = false;
    const resolveActiveSession = async () => {
      if (checking) return;
      checking = true;
      try {
        const { activeSession } = await clientApi.getActiveSession();
        if (cancelled) return;
        if (activeSession) {
          location.replace(`/s/${activeSession.slug}`);
          return;
        }
        setState("waiting");
      } catch {
        if (!cancelled) setState("error");
      } finally {
        checking = false;
      }
    };
    void resolveActiveSession();
    const timer = window.setInterval(resolveActiveSession, 2500);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  return (
    <main className="home-page" id="main">
      <header className="site-header">
        <Brand club />
        <StatusBadge tone={state === "error" ? "yellow" : "green"}>
          {state === "resolving" ? "Buscando sesión" : state === "waiting" ? "En espera" : "Reconectando"}
        </StatusBadge>
      </header>
      <section className="home-hero active-entry">
        <div className="hero-copy">
          <div className="waiting-kicker">
            <span>01</span>
            <span>¿CUÁNTO CUESTA VIVIR EN LA NUBE?</span>
          </div>
          <h1>{state === "resolving" ? "Entrando a la sesión…" : "Comenzamos en un momento"}</h1>
          <p>
            {state === "error"
              ? "No pudimos consultar la sesión. Esta pantalla volverá a intentarlo automáticamente."
              : "Deja esta pantalla abierta. Cuando el administrador inicie la dinámica, entrarás automáticamente sin código ni registro."}
          </p>
          <div className="active-entry-status" aria-live="polite">
            <span className="loader" aria-hidden="true">
              <span />
              <span />
              <span />
            </span>
            <span className="active-entry-status-copy">
              <small>ESTADO DE LA SESIÓN</small>
              <strong>
                {state === "resolving"
                  ? "Localizando la sala activa"
                  : state === "waiting"
                    ? "Esperando a que se abra la sala"
                    : "Reintentando conexión"}
              </strong>
            </span>
          </div>
          <small className="privacy-note">
            Sin registro, sin correo y sin nombres. Tu respuesta se suma de forma anónima.
          </small>
        </div>
        <div className="hero-visual" aria-label="Resumen de la dinámica">
          <span className="terminal-label">HELLO WORLD LAB · EN VIVO</span>
          <div className="terminal-card">
            <div className="terminal-top">
              <span />
              <span />
              <span />
              <strong>nube@casa</strong>
            </div>
            <p>
              <span>$</span> contar_suscripciones
            </p>
            <div className="terminal-steps">
              <p>
                <strong>01</strong> Conocer
              </p>
              <p>
                <strong>02</strong> Comparar
              </p>
              <p>
                <strong>03</strong> Decidir
              </p>
            </div>
          </div>
          <blockquote>
            “Una charla sobre lo que usamos, lo que consumimos y lo que podríamos
            controlar.”
          </blockquote>
        </div>
      </section>
      <CommunityFooter
        brandHref="#main"
        className="home-community-footer"
      />
    </main>
  );
}
